// Who may reach the 365 Licences feature. Every nav entry and page gate in the
// feature reads from here, so none of them can drift apart.
//
// CspAdmin is an entitlement, not a job role: it grants nothing on its own. The
// controller's class-level [Authorize] ANDs with each action's, so a caller needs
// CspAdmin AND a functional role. Thresholds, approvals and the Activity Log all
// still resolve on Admin/Sales/ITManager/SSE.
//
// GA: restore ['Admin', 'Sales', 'ITManager', 'SSE'] and drop the class attribute.
//
// Presentation only - the controller is the access control.
export const LICENCE_FEATURE_ROLES = ['CspAdmin']

/**
 * True when the given AAD roles may use the feature. Pass REAL roles, not the
 * dev-impersonation effective set: impersonation exists to switch between roles
 * you already hold, not to grant access, and the server enforces real roles
 * regardless.
 */
export const canUseLicenceFeature = (roles) =>
  (roles || []).some((r) => LICENCE_FEATURE_ROLES.includes(r))
